import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Quote } from '../model/quote';
import { QuoteSummary } from '../model/quote-summary';
import { Constants } from '../model/constants';
import { AuthenticatedHttpService } from './authenticatedhttp.service';

import { CurrentUserService } from './current-user.service';
import { QuoteRevision } from '../model/quote-revision';

@Injectable()
export class QuoteService {
    private baseUrl;
    private _quoteCache: Quote;
    private base64Placeholder: string =
        // tslint:disable-next-line: max-line-length
        'data:image/png;base64,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';

    constructor(private _http: AuthenticatedHttpService, private currentUserService: CurrentUserService) {
        this._quoteCache = undefined;
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    setLockQuoteStatus(quoteId: number, locked: boolean, currentUserId: number) {
        //  this.spinner.addSpinnerControlItem('setLockQuoteStatus');
       
        quoteId = quoteId !== undefined && quoteId !== null ? quoteId : 0;
        currentUserId = currentUserId !== undefined && currentUserId !== null ? currentUserId : 0;

        this._http.post(`${this.baseUrl}/api/quotes/set-lock-status/${quoteId}/${locked}/${currentUserId}`, null).subscribe();
    }

    setLockQuoteStatusOnRedirectOrClose(quoteId: number, locked: boolean, currentUserId: number) {
        //  let options = this._http.request;
        quoteId = quoteId !== undefined && quoteId !== null ? quoteId : 0;
        currentUserId = currentUserId !== undefined && currentUserId !== null ? currentUserId : 0;

        let xhr = new XMLHttpRequest();
        xhr.open('POST', `${this.baseUrl}/api/quotes/set-lock-status/${quoteId}/${locked}/${currentUserId}`, false);
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.setRequestHeader('Authorization', this._http.getBearerTokenForHeader);
        xhr.send();
    }

    insertQuote(quote: Quote): Observable<Quote> {
        
        return this._http
            .post(this.baseUrl + '/api/quotes/', JSON.stringify(quote))
            .map(x => {
                let returnQuote = new Quote();
                returnQuote = this.mapQuote(x.json());
                return returnQuote;
            })
            .catch((error: any) => Observable.throw(error.json().error));
    }

    updateQuote(quote: Quote): Observable<Quote> {
        let currentUserId =
            this.currentUserService.currentUser$ !== undefined &&
            this.currentUserService.currentUser$ !== null &&
            this.currentUserService.currentUser$.value !== undefined &&
            this.currentUserService.currentUser$.value !== null &&
            this.currentUserService.currentUser$.value.cmhUserId !== undefined &&
            this.currentUserService.currentUser$.value.cmhUserId !== null
                ? Number(this.currentUserService.currentUser$.value.cmhUserId)
                : 0;
        quote.LockedBy = currentUserId;
        // reset iSeriesQuoteNumber if status is not approved.
        quote.iseriesQuoteNumber =
            quote.approvalStatus === Constants.QuoteApprovalStatus.NOT_SUBMITTED ||
            quote.approvalStatus === Constants.QuoteApprovalStatus.PENDING_APPROVAL ||
            quote.approvalStatus === Constants.QuoteApprovalStatus.DECLINED
                ? 0
                : quote.iseriesQuoteNumber;

        return this._http
            .put(this.baseUrl + `/api/quotes/${quote.quoteId}`, JSON.stringify(quote))
            .map(x => {
                let returnQuote = new Quote();
                returnQuote = this.mapQuote(x.json());
                return returnQuote;
            })
            .catch((error: any) => Observable.throw(error.json().error));
    }

    updateQuoteCreateNewRevision(quoteRevision: QuoteRevision): Observable<Quote> {
        return this._http
            .post(this.baseUrl + `/api/quotes/createrevision`, JSON.stringify(quoteRevision))
            .map(x => {
                let returnQuote = new Quote();
                returnQuote = this.mapQuote(x.json());
                return returnQuote;
            })
            .catch((error: any) => Observable.throw(error.json().error));
    }

    mapQuote(apiQuote): Quote {
        if (apiQuote !== undefined && apiQuote !== null) {
            let quote: Quote = new Quote();
            quote.quoteId = apiQuote.QuoteId;
            quote.productLineId = apiQuote.ProductLineId;
            quote.modelId = apiQuote.ModelId;
            quote.customerId = apiQuote.CustomerId;
            quote.userId = apiQuote.UserId;
            quote.DateApproved = apiQuote.DateApproved;
            quote.retailerNumber = apiQuote.RetailerNumber;
            quote.plantId = apiQuote.PlantId;
            quote.createdBy = apiQuote.CreatedBy;
            quote.modifiedBy = apiQuote.ModifiedBy !== undefined ? apiQuote.ModifiedBy : '';
            quote.IsLocked = apiQuote.IsLocked;
            quote.LockedBy = apiQuote.LockedBy;
            quote.plantNumber = apiQuote.PlantNumber;
            quote.plantName = apiQuote.PlantName;
            quote.modelDesc = apiQuote.ModelDesc;
            quote.inactiveStatus = apiQuote.InactiveStatus;
            quote.status = quote.inactiveStatus ? 'Inactive' : 'Active';
            quote.mdm = apiQuote.MDM;
            quote.customer = apiQuote.Customer;
            quote.retailerName = apiQuote.RetailerName;
            if (apiQuote.DateCreated === null) {
                quote.DateCreated = new Date();
            } else {
                quote.DateCreated = apiQuote.DateCreated;
            }
            if (quote.LastModifiedDate === null) {
                quote.LastModifiedDate = new Date();
            } else {
                quote.LastModifiedDate = apiQuote.LastModifiedDate;
            }
            quote.QuoteStatusesID = apiQuote.QuoteStatusesID;
            quote.approvalStatus = apiQuote.QuoteStatusesID;
            quote.ApprovalStatusDescription = apiQuote.ApprovalStatusDescription;
            if (quote.expirationDate === null) {
                quote.expirationDate = new Date();
            } else {
                quote.expirationDate = apiQuote.ExpirationDate;
            }
            quote.prospectId = apiQuote.ProspectId;
            quote.iseriesQuoteNumber = apiQuote.ISeriesQuoteNumber;
            quote.BaseCost = apiQuote.BaseCost || 0;
            quote.DiscountPercent = apiQuote.DiscountPercent || 0;
            quote.Dues = apiQuote.Dues || 0;
            quote.GrandTotal = apiQuote.GrandTotal || 0;
            quote.ModelBaseCost = apiQuote.ModelBaseCost || 0;
            quote.ModelBaseOverride = apiQuote.ModelBaseOverride || 0;
            quote.OptionsTotal = apiQuote.OptionsTotal || 0;
            quote.Surcharge = apiQuote.Surcharge || 0;
            quote.Taxes = apiQuote.Taxes || 0;
            quote.Transportation = apiQuote.Transportation || 0;
            quote.CurrentPage = apiQuote.CurrentPage || 1;
            quote.TotalPageCount = apiQuote.TotalPageCount || 0;
            quote.revisionNumber = apiQuote.RevisionNumber || null;
            quote.revisionComments = apiQuote.RevisionComments || null;

            return quote;
        } else {
            return undefined;
        }
    }

    getQuoteById(quoteId: number, refresh = false): Observable<Quote> {
        let currentUserId =
            this.currentUserService.currentUser$ !== undefined &&
            this.currentUserService.currentUser$ !== null &&
            this.currentUserService.currentUser$.value !== undefined &&
            this.currentUserService.currentUser$.value !== null &&
            this.currentUserService.currentUser$.value.cmhUserId !== undefined &&
            this.currentUserService.currentUser$.value.cmhUserId !== null
                ? Number(this.currentUserService.currentUser$.value.cmhUserId)
                : 0;
        if (this._quoteCache && this._quoteCache.quoteId && !refresh) {
            return Observable.of(this._quoteCache);
        } else {
            return this._http
                .get(this.baseUrl + `/api/quotes/${quoteId}/${currentUserId}`)
                .map(response => {
                    let returnQuote = new Quote();
                    if (response !== null) {
                        this._quoteCache = this.mapQuote(response.json());
                        returnQuote = this.mapQuote(response.json());
                    } else {
                        this._quoteCache = null;
                    }

                    return returnQuote;
                })
                .catch(this._http.handleError);
        }
    }

    getQuoteSummary(quoteId, customerId): Observable<QuoteSummary> {
        return this._http
            .get(`${this.baseUrl}/api/quotesummary/${quoteId}/${customerId}`)
            .map(x => {
                let qs: QuoteSummary = x.json();
                if (qs.DateCreated === null) {
                    qs.DateCreated = new Date();
                }
                if (qs.LastModifiedDate === null) {
                    qs.LastModifiedDate = new Date();
                }
                if (qs.ModelBaseOverride > 0) {
                    qs.BaseCost = qs.ModelBaseOverride;
                }
                return qs;
            })
            .catch(this._http.handleError);
    }

    getQuoteSummaryNoPricing(quoteId, customerId): Observable<QuoteSummary> {
        return this._http
            .get(`${this.baseUrl}/api/quotesummary/${quoteId}/${customerId}/nopricing`)
            .map(x => {
                let qs: QuoteSummary = x.json();
                if (qs.DateCreated === null) {
                    qs.DateCreated = new Date();
                }
                if (qs.LastModifiedDate === null) {
                    qs.LastModifiedDate = new Date();
                }
                return qs;
            })
            .catch(this._http.handleError);
    }

    sendPdf(body) {
        return this._http
            .post(`${this.baseUrl}/api/quotesummary/emailQuote`, body)
            .map(response => {
                return response.json();
            })
            .catch(this._http.handleError);
    }

    createiSeriesOrder(quoteId: number, refresh = false): Observable<number> {
        return this._http
            .get(this.baseUrl + `/api/quotes/${quoteId}/createiseriesorder`)
            .map(response => {
                let returnOrderNumber = 0;
                if (response !== null) {
                    returnOrderNumber = response.json();
                }

                return returnOrderNumber;
            })
            .catch(this._http.handleError);
    }

    getBase64Logo() {
        return this.base64Placeholder;
    }

    getBase64WaterMark() {
        return Constants.waterMarkBase64;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/quote.service.ts